export default __webpack_public_path__ + "static/media/Main_Brochure-low.367f31c2.pdf";